export var RoomType;
(function (RoomType) {
    RoomType["instant"] = "instant";
    RoomType["scheduled"] = "schedule";
    RoomType["public"] = "public";
})(RoomType || (RoomType = {}));
